import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import VueSweetalert2 from 'vue-sweetalert2';
import VueI18n from 'vue-i18n'
import 'sweetalert2/dist/sweetalert2.min.css';
import ToastPlugin from 'vue-toast-notification';
import dotenv from 'dotenv'
dotenv.config({ path: `.env.${process.env.NODE_ENV}` })
import DateRangePicker from 'vue2-daterange-picker'
import 'vue-toast-notification/dist/theme-sugar.css';



window.$ = window.jQuery = require('jquery')
import './assets/css/style.css'
import './assets/css/print.css'
import './assets/css/style.scss'

Vue.use(VueSweetalert2);
Vue.use(DateRangePicker);
Vue.use(VueI18n)
Vue.use(ToastPlugin);
Vue.component("date-range-picker",DateRangePicker)



//VueRangedatePicker.default.install(Vue)
Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')


